"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainMenu = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var MenuItem_1 = require("../MenuItem/MenuItem");
var Navbar_types_1 = require("../Navbar.types");
var utils_1 = require("../utils");
require("./MainMenu.css");
var MainMenu = function (props) {
    var i18n = props.i18n, menuItemProps = __rest(props, ["i18n"]);
    var urls = (0, utils_1.getNavbarPagesUrls)();
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('dui-navbar__menu', !props.isMobile && 'dui-navbar__menu-desktop', props.isMobile && 'dui-navbar__menu-mobile') },
        react_1.default.createElement(MenuItem_1.MenuItem, __assign({}, menuItemProps, { section: Navbar_types_1.NavbarPages.MARKETPLACE, title: i18n.marketplace, mainUrl: urls[Navbar_types_1.NavbarPages.MARKETPLACE] })),
        react_1.default.createElement(MenuItem_1.MenuItem, __assign({}, menuItemProps, { section: Navbar_types_1.NavbarPages.CREATE, title: i18n.create, mainUrl: urls[Navbar_types_1.NavbarPages.CREATE] })),
        react_1.default.createElement(MenuItem_1.MenuItem, __assign({}, menuItemProps, { section: Navbar_types_1.NavbarPages.EXPLORE, title: i18n.explore, mainUrl: urls[Navbar_types_1.NavbarPages.EXPLORE] })),
        react_1.default.createElement(MenuItem_1.MenuItem, __assign({}, menuItemProps, { section: Navbar_types_1.NavbarPages.LEARN, title: i18n.learn, mainUrl: urls[Navbar_types_1.NavbarPages.LEARN] })),
        react_1.default.createElement(MenuItem_1.MenuItem, __assign({}, menuItemProps, { section: Navbar_types_1.NavbarPages.GOVERNANCE, title: i18n.governance, mainUrl: urls[Navbar_types_1.NavbarPages.GOVERNANCE] }))));
};
exports.MainMenu = MainMenu;
